/* eslint-disable jsx-a11y/iframe-has-title */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useMemo, useRef, useState } from "react";
import { CssCases } from "./css";
import { useTranslation } from "react-i18next";
import ReactHtmlParser from "html-react-parser";

// Imagens
import FotoHomem from "../../assets/Images/fotoHomem.png";
import FotoPa from "../../assets/Images/fotoPa.png";
import EfeitoAzulCheio from "../../assets/Images/efeitoAzulCheio.png";
import ZAzul from "../../assets/Images/z-azul.png";
import whatsApp from "../../assets/Images/whatsappBranco.png";
import SetaAzul from "../../assets/Images/arrow.png";

import { Dialog } from "primereact/dialog";
import { TabView, TabPanel } from "primereact/tabview";

import CasesEstrategia from "../../assets/Images/Case-Estrategia-Conteudo-Social.jpg";
import CasesEventos from "../../assets/Images/Case-Eventos.jpg";
import CasesCampanhas from "../../assets/Images/Case-Campanhas.jpg";
import CasesTransmissao from "../../assets/Images/Case-Transmissao-AoVivo.jpg";
import CasesRealTime from "../../assets/Images/Case-Real-Time.jpg";

import BarraBege from "../../assets/Images/barraBege.png";
import BarraBegeVazia from "../../assets/Images/barraBegeVazia.png";


let larguraTela = window.innerWidth;

const Cases = () => {
	const { t, i18n } = useTranslation();

	const rootRef = useRef(null);
	//const [showButton, setShowButton] = useState(false);
	const [inView, setInView] = useState(false);

	// overlays só entram depois das animações principais
	const [showManOverlay, setShowManOverlay] = useState(false);
	const [showPaOverlay, setShowPaOverlay] = useState(false);

	// texto do parágrafo sem efeito de digitação
	//const fullParagraph = useMemo(() => t("cases.paragraph"), [i18n.language, t]);

	// Cases
	const [modalCases, setModalCases] = useState(false);
	const [alturaVideo, setAlturaVideo] = useState("360px");

	const [activeTab, setActiveTab] = useState(0);

	const whatsappLink =
		i18n.language === "en"
			? "https://wa.me/5511980130098?text=Hello%2C%20I%20found%20ZEST%20through%20your%20website%20and%20would%20like%20to%20understand%20how%20you%20can%20help%20my%20brand%20grow."
			: "https://wa.me/5511980130098?text=Ol%C3%A1%2C%20vim%20pelo%20site%20da%20ZEST%20e%20quero%20entender%20como%20voc%C3%AAs%20podem%20ajudar%20minha%20marca%20a%20crescer.";

	// counters
	const stats = useMemo(
		() => [
			{ key: "views", value: 18, suffix: "mi", label: t("cases.stats.views") },
			{ key: "lives", value: 95, suffix: "", label: t("cases.stats.lives") },
			{ key: "hours", value: 520, suffix: "h", label: t("cases.stats.hours") },
			{ key: "videos", value: 420, suffix: "", label: t("cases.stats.videos") },
			{ key: "events", value: 180, suffix: "", label: t("cases.stats.events") },
			{ key: "meters", value: 28, suffix: "k", label: t("cases.stats.meters") },
			{ key: "states", value: 15, suffix: "", label: t("cases.stats.states") },
			{ key: "people", value: 45, suffix: "k", label: t("cases.stats.people") },
		],
		[i18n.language, t]
	);

	const casesLinks = useMemo(
		() => [
			{
				id: 1,
				imagem: CasesEstrategia,
				titulo: "Estragéia de Conteúdo Social",
				subtitulo: "",
				link: "/CasesConteudoSocial",
			},
			{
				id: 2,
				imagem: CasesEventos,
				titulo: "Eventos",
				subtitulo: "",
				link: "/CasesjogarJunto",
			},			
			 {
				id: 3,
				imagem: CasesCampanhas,
				titulo: "Campanhas",
				subtitulo: "",
				link: "/CasesCampanhas",
			}, 
			{
				id: 4,
				imagem: CasesTransmissao,
				titulo: "Transmissão ao Vivo",
				subtitulo: "",
				link: "/CasesTransmissaoAoVivo",
			},
			{
				id: 5,
				imagem: CasesRealTime,
				titulo: "Transmissão em Tempo Real",
				subtitulo: "",
				link: "/CasesRealTime",
			},
		],
		[]
	);

	const [counts, setCounts] = useState(() =>
		stats.reduce((acc, s) => {
			acc[s.key] = 0;
			return acc;
		}, {})
	);

	// Observer
	useEffect(() => {
		const el = rootRef.current;
		if (!el) return;

		if (!("IntersectionObserver" in window)) {
			setInView(true);
			return;
		}

		const obs = new IntersectionObserver(
			([entry]) => {
				if (entry.isIntersecting) {
					setInView(true);
					obs.disconnect();
				}
			},
			{
				threshold: 0.2,
				rootMargin: "0px 0px -10% 0px",
			}
		);

		obs.observe(el);
		return () => obs.disconnect();
	}, []);

	// Reset ao trocar idioma
	useEffect(() => {
		setCounts(
			stats.reduce((acc, s) => {
				acc[s.key] = 0;
				return acc;
			}, {})
		);

		setShowManOverlay(false);
		setShowPaOverlay(false);
		//setShowButton(false);

		if (inView) {
			const t1 = setTimeout(() => setShowPaOverlay(true), 1100);
			const t2 = setTimeout(() => setShowManOverlay(true), 1400);
			//const t3 = setTimeout(() => setShowButton(true), 900);

			return () => {
				clearTimeout(t1);
				clearTimeout(t2);
				//clearTimeout(t3);
			};
		}
	}, [i18n.language]);

	// Overlays depois das animações principais
	useEffect(() => {
		if (!inView) return;

		const t1 = setTimeout(() => setShowPaOverlay(true), 1100);
		const t2 = setTimeout(() => setShowManOverlay(true), 1400);

		return () => {
			clearTimeout(t1);
			clearTimeout(t2);
		};
	}, [inView]);

	// Botão aparece depois que a seção entra em view
	useEffect(() => {
		if (inView) {
			const timer = setTimeout(() => {
				//setShowButton(true);
			}, 900);

			return () => clearTimeout(timer);
		} else {
			//setShowButton(false);
		}
	}, [inView]);

	// Counters
	useEffect(() => {
		if (!inView) return;

		const duration = 1200;
		const start = performance.now();

		let raf = 0;

		function tick(now) {
			const p = Math.min(1, (now - start) / duration);

			const ease = 1 - Math.pow(1 - p, 3);

			const nextCounts = {};
			for (const s of stats) {
				nextCounts[s.key] = Math.round(s.value * ease);
			}

			setCounts(nextCounts);

			if (p < 1) {
				raf = requestAnimationFrame(tick);
			}
		}

		raf = requestAnimationFrame(tick);
		return () => cancelAnimationFrame(raf);
	}, [inView, stats]);

	useEffect(() => {
		if (larguraTela < 850) {
			setAlturaVideo("230px");
		}
	}, [larguraTela]);

	const [depoimentoIndex, setDepoimentoIndex] = useState(0);
	const [testimonialVisible, setTestimonialVisible] = useState(true);
	const [testimonialDirection, setTestimonialDirection] = useState("next");

	const depoimentos = useMemo(
		() => [
			{
				id: 1,
				nome: "Felipe Sapucahy",
				cargo: t("cases.deps.cargo1"),
				texto: t("cases.deps.dep1"),
			},
			{
				id: 2,
				nome: "Rodrigo Trevizani",
				cargo: t("cases.deps.cargo6"),
				texto: t("cases.deps.dep6"),
			},
			{
				id: 3,
				nome: "Giovanni Santos",
				cargo: t("cases.deps.cargo3"),
				texto: t("cases.deps.dep3"),
			},
			{
				id: 4,
				nome: "Rafael Valim",
				cargo: t("cases.deps.cargo4"),
				texto: t("cases.deps.dep4"),
			},
			{
				id: 5,
				nome: "Ana Paula Rodrigues",
				cargo: t("cases.deps.cargo5"),
				texto: t("cases.deps.dep5"),
			},
			{
				id: 6,
				nome: "William Gibini",
				cargo: t("cases.deps.cargo2"),
				texto: t("cases.deps.dep2"),
			},
			{
				id: 7,
				nome: "Marcos Dutra",
				cargo: t("cases.deps.cargo7"),
				texto: t("cases.deps.dep7"),
			},
			{
				id: 8,
				nome: "Julia Reina",
				cargo: t("cases.deps.cargo8"),
				texto: t("cases.deps.dep8"),
			},
		],
		[t, i18n.language]
	);

	const visibleCount = window.innerWidth <= 768 ? 1 : 2;

	const depoimentosVisiveis = useMemo(() => {
		const items = [];

		for (let i = 0; i < visibleCount; i += 1) {
			items.push(depoimentos[(depoimentoIndex + i) % depoimentos.length]);
		}

		return items;
	}, [depoimentoIndex, depoimentos, visibleCount]);

	const nextDepoimento = () => {
		setTestimonialDirection("next");
		setTestimonialVisible(false);

		setTimeout(() => {
			setDepoimentoIndex((prev) => (prev + visibleCount) % depoimentos.length);
			setTestimonialVisible(true);
		}, 260);
	};

	const prevDepoimento = () => {
		setTestimonialDirection("prev");
		setTestimonialVisible(false);

		setTimeout(() => {
			setDepoimentoIndex((prev) => {
				const next = prev - visibleCount;
				return next < 0 ? Math.max(depoimentos.length - visibleCount, 0) : next;
			});
			setTestimonialVisible(true);
		}, 260);
	};

	const toggleCases = () => {
		setModalCases(!modalCases);
	};

	return (
		<CssCases ref={rootRef} className="casesWrap">
			<section className="cases" id="cases">
				<div className="cases__inner">
					{/* LEFT */}
					<div className="cases__left">
						{/* foto PA */}
						<div className={`cases__photoPaWrap ${inView ? "is-in" : ""}`}>
							<img className="cases__photoPa" src={FotoPa} alt="" />

							{/* z-azul */}
							<img
								className={`cases__zOverlay ${showPaOverlay ? "is-show" : ""}`}
								src={ZAzul}
								alt=""
								aria-hidden="true"
							/>
						</div>

						<h2 className={`cases__titleA ${inView ? "is-in" : ""}`}>
							{ReactHtmlParser(t("cases.titleA"))}
						</h2>

						<h3 className={`cases__titleB ${inView ? "is-in" : ""}`}>
							{ReactHtmlParser(t("cases.titleB"))}
						</h3>
					</div>

					{/* RIGHT */}
					<div className="cases__right">
						{/* homem */}
						<div className={`cases__manWrap ${inView ? "is-in" : ""}`}>
							<img className="cases__man" src={FotoHomem} alt="" />

							<img
								className={`cases__manOverlay ${
									showManOverlay ? "is-show" : ""
								}`}
								src={EfeitoAzulCheio}
								alt=""
								aria-hidden="true"
							/>
						</div>

						{/* parágrafo sem digitação */}
							{/* <div className="cases__descWrap">
								<p className={`cases__desc ${inView ? "is-in" : ""}`}>
									{fullParagraph} 
								</p> 							
							</div> */}
					</div>
				</div>

				<div className="cases__linksArea">
					<img
						className={`cases__barraBege ${inView ? "is-in" : ""}`}
						src={BarraBege}
						alt=""
						aria-hidden="true"
					/>

					<img
						className={`cases__barraBegeVazia ${inView ? "is-in" : ""}`}
						src={BarraBegeVazia}
						alt=""
						aria-hidden="true"
					/>

					<h2 className={`cases__linksTitle ${inView ? "is-in" : ""}`}>
						{ReactHtmlParser(t("cases.conhecaCases"))}
					</h2>

					<div className="cases__linksWrap">
						{casesLinks.map((item, index) => (
							<a
								key={item.id}
								href={item.link}
								className={`cases__linkCard ${inView ? "is-in" : ""}`}
								style={{ transitionDelay: `${150 + index * 130}ms` }}
							>
								<img src={item.imagem} alt={`${item.titulo} - ${item.subtitulo}`} />
							</a>
						))}
					</div>
				</div>

				{/* STATS */}
				<div className="cases__statsWrap">
					<h3 className="cases__statsTitle">{t("cases.oqdizem")}</h3>

					<div className="cases__stats">
						{stats.map((s) => (
							<div className="stat" key={s.key}>
								<div className="stat__num">
									{counts[s.key]}
									{s.suffix} +
								</div>
								<div className="stat__label">{s.label}</div>
							</div>
						))}
					</div>
				</div>

				<div className="cases__videos">
					<a
						href={whatsappLink}
						className="btnTalk is-show btnTalkCases"
						target="_blank"
						rel="noreferrer"
					>
						<span>
							{t("home.faleConosco")}{" "}
							<img src={whatsApp} alt="WhatsApp" title="WhatsApp" />
						</span>
					</a>
				</div>

				{/* Depoimentos */}
				<div className="cases__testimonials">
					<h3 className="cases__testimonialsTitle">
						{t("cases.deps.tituloDepoimentos")}
					</h3>

					<div className="cases__testimonialsNav">
						<button
							type="button"
							className="cases__arrow cases__arrow--left"
							onClick={prevDepoimento}
							aria-label="Depoimentos anteriores"
						>
							<img src={SetaAzul} alt="Anterior" />
						</button>

						<button
							type="button"
							className="cases__arrow cases__arrow--right"
							onClick={nextDepoimento}
							aria-label="Próximos depoimentos"
						>
							<img src={SetaAzul} alt="Próximo" />
						</button>
					</div>

					<div
						className={`cases__testimonialsGrid ${
							testimonialVisible ? "is-visible" : "is-hidden"
						} ${testimonialDirection === "next" ? "is-next" : "is-prev"}`}
					>
						{depoimentosVisiveis.map((item) => (
							<article className="cases__testimonial" key={item.id}>
								<p className="cases__testimonialText">“{item.texto}”</p>

								<div className="cases__testimonialAuthor">
									<strong>{item.nome}</strong>
									<span>{item.cargo}</span>
								</div>
							</article>
						))}
					</div>
				</div>

				<Dialog
					header=""
					visible={modalCases}
					onHide={() => {
						toggleCases();
					}}
					id="modalBlue"
					style={{ width: "40vw" }}
					breakpoints={{ "960px": "75vw", "641px": "100vw" }}
				>
					<div className="detailVideos">
						<TabView
							activeIndex={activeTab}
							onBeforeTabChange={(e) => {
								if (e.index === 3) {
									window.open(whatsappLink, "_blank");
									return false;
								}

								return true;
							}}
							onTabChange={(e) => {
								setActiveTab(e.index);
							}}
						>
							<TabPanel header="Suvinil">
								<p className="m-0">
									<iframe
										src="https://player.vimeo.com/video/1187104319"
										width="100%"
										height={alturaVideo}
										allow="autoplay; fullscreen; picture-in-picture"
										allowFullScreen
									/>
								</p>
							</TabPanel>

							<TabPanel header="Ecom">
								<p className="m-0">
									<iframe
										src="https://player.vimeo.com/video/1059824893"
										width="100%"
										height={alturaVideo}
										allow="autoplay; fullscreen; picture-in-picture"
										allowFullScreen
									/>
								</p>
							</TabPanel>

							<TabPanel header="SuperBonder">
								<p className="m-0">
									<iframe
										src="https://player.vimeo.com/video/1059827059"
										width="100%"
										height={alturaVideo}
										allow="autoplay; fullscreen; picture-in-picture"
										allowFullScreen
									/>
								</p>
							</TabPanel>

							<TabPanel header={t("cases.vejaOutros")}>
								<p className="m-0"></p>
							</TabPanel>
						</TabView>
					</div>
				</Dialog>
			</section>
		</CssCases>
	);
};

export default Cases;